import { Context } from '@nuxt/types'

export default ({ store }: Context) => {
  store.dispatch('google-showcase/initialize')
}
